<div class="rf" [class.rf--compact]="compact">
  @if (!compact) {
    <div class="rf__toolbar" role="toolbar" [attr.aria-label]="'RICH_TEXT.TOOLBAR' | translate">
      <button
        type="button"
        class="rf__tool"
        (mousedown)="$event.preventDefault()"
        (click)="bold()"
        [title]="'RICH_TEXT.BOLD_HINT' | translate"
        [attr.aria-label]="'RICH_TEXT.BOLD' | translate">
        <i class="fa-solid fa-bold" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="rf__tool rf__tool--label"
        (mousedown)="$event.preventDefault()"
        (click)="openFormula(false)"
        [title]="'RICH_TEXT.FORMULA_HINT' | translate">
        <span class="rf__fx" aria-hidden="true">√x</span>
        {{ 'RICH_TEXT.FORMULA' | translate }}
      </button>
      @if (multiline) {
        <button
          type="button"
          class="rf__tool rf__tool--label"
          (mousedown)="$event.preventDefault()"
          (click)="openFormula(true)"
          [title]="'RICH_TEXT.FORMULA_DISPLAY_HINT' | translate">
          <span class="rf__fx" aria-hidden="true">∑</span>
          {{ 'RICH_TEXT.FORMULA_DISPLAY' | translate }}
        </button>
      }
    </div>
  }

  <div class="rf__field">
    <ng-content></ng-content>
    @if (compact) {
      <button
        type="button"
        class="rf__tool rf__tool--inline"
        (mousedown)="$event.preventDefault()"
        (click)="openFormula(false)"
        [title]="'RICH_TEXT.FORMULA_HINT' | translate"
        [attr.aria-label]="'RICH_TEXT.FORMULA' | translate">
        <span class="rf__fx" aria-hidden="true">√x</span>
      </button>
    }
  </div>

  @if (showPreview()) {
    <div class="rf__preview">
      <span class="rf__preview-label">{{ 'RICH_TEXT.PREVIEW' | translate }}</span>
      <app-math-text class="rf__preview-text" [text]="value()"></app-math-text>
    </div>
  }
</div>

<!--
  Fenêtre native plein écran, transparente : le panneau y est centré en grille,
  comme les autres fenêtres de l'application. Le centrage par défaut du
  navigateur se décalait en arabe.
-->
<dialog
  #dialog
  class="rf-dialog"
  (close)="onClosed()"
  (pointerdown)="onDialogPointerDown($event)"
  (click)="onDialogClick($event)"
  [attr.aria-label]="'RICH_TEXT.DIALOG_TITLE' | translate">
  <div class="rf-dialog__panel">
    <h2 class="rf-dialog__title">
      {{ (editing() ? 'RICH_TEXT.DIALOG_EDIT_TITLE' : 'RICH_TEXT.DIALOG_TITLE') | translate }}
    </h2>

    <!-- Les raccourcis sont des signes latins : chacun est isolé de gauche à
         droite, sans quoi la phrase arabe qui les entoure se réordonne. -->
    <div class="rf-dialog__help">
      <span>{{ 'RICH_TEXT.HELP_INTRO' | translate }}</span>
      <ul class="rf-dialog__keys">
        <li><kbd dir="ltr">/</kbd> {{ 'RICH_TEXT.KEY_FRACTION' | translate }}</li>
        <li><kbd dir="ltr">^</kbd> {{ 'RICH_TEXT.KEY_POWER' | translate }}</li>
        <li><kbd dir="ltr">_</kbd> {{ 'RICH_TEXT.KEY_INDEX' | translate }}</li>
        <li><kbd dir="ltr">sqrt</kbd> {{ 'RICH_TEXT.KEY_ROOT' | translate }}</li>
        <li><kbd dir="ltr">alpha</kbd> <bdi dir="ltr">α</bdi></li>
      </ul>
      <span class="rf-dialog__help-keyboard">
        <i class="fa-regular fa-keyboard" aria-hidden="true"></i>
        {{ 'RICH_TEXT.HELP_KEYBOARD' | translate }}
      </span>
    </div>

    <div #mathHost class="rf-dialog__math" dir="ltr"></div>

    @if (loadError()) {
      <p class="rf-dialog__error">{{ 'RICH_TEXT.LOAD_ERROR' | translate }}</p>
    }
    @if (incomplete()) {
      <p class="rf-dialog__hint" role="status">
        <i class="fa-regular fa-square" aria-hidden="true"></i>
        {{ 'RICH_TEXT.INCOMPLETE' | translate }}
      </p>
    }
    @if (tooLong()) {
      <p class="rf-dialog__error" role="alert">{{ 'RICH_TEXT.TOO_LONG' | translate }}</p>
    }

    <details class="rf-dialog__source" [open]="loadError()">
      <summary>{{ 'RICH_TEXT.LATEX_SOURCE' | translate }}</summary>
      <textarea
        class="form-control rf-dialog__latex"
        dir="ltr"
        rows="2"
        spellcheck="false"
        [attr.aria-label]="'RICH_TEXT.LATEX_SOURCE' | translate"
        [value]="latex()"
        (input)="onLatexInput($any($event.target).value)"></textarea>
      @if (latex().trim()) {
        <div class="rf-dialog__render">
          <app-math-text [text]="delimited()"></app-math-text>
        </div>
      }
    </details>

    @if (multiline) {
      <label class="rf-dialog__display">
        <input
          type="checkbox"
          class="form-check-input"
          [checked]="display()"
          (change)="display.set($any($event.target).checked)" />
        {{ 'RICH_TEXT.DISPLAY_TOGGLE' | translate }}
      </label>
    }

    <div class="rf-dialog__actions">
      @if (editing()) {
        <button type="button" class="rf-dialog__btn rf-dialog__btn--danger" (click)="remove()">
          {{ 'RICH_TEXT.REMOVE' | translate }}
        </button>
      }
      <span class="rf-dialog__spacer"></span>
      <button type="button" class="rf-dialog__btn" (click)="close()">
        {{ 'RICH_TEXT.CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="rf-dialog__btn rf-dialog__btn--primary"
        [disabled]="!latex().trim() || incomplete()"
        (click)="confirm()">
        {{ (editing() ? 'RICH_TEXT.UPDATE' : 'RICH_TEXT.INSERT') | translate }}
      </button>
    </div>
  </div>

  <!-- Le clavier virtuel de MathLive s'affiche ici, en bas de la fenêtre :
       posé dans la page, il passerait sous la couche supérieure. -->
  <div #keyboardHost class="rf-dialog__keyboard" dir="ltr"></div>
</dialog>
